import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import { ReacTableStyles, ActionRendererWrapper } from './styled';

const DataTable = props => (
    <ReacTableStyles>
        <ReactTable {...props} />
    </ReacTableStyles>
);

const DateTimeRenderer = row => (<span title={row.value}>{new Date(row.value).toString().split('G')[0]}</span>);
const CellRenderer = row => (<span title={row.value}>{row.value}</span>);
const ActionRenderer = props => (<ActionRendererWrapper className={'data-table-action-wrapper'}>{props.children}</ActionRendererWrapper>);

ActionRenderer.propTypes = {
    children: PropTypes.node
};

export { DataTable, CellRenderer, ActionRenderer, DateTimeRenderer };



// WEBPACK FOOTER //
// ./app/components/data-table/index.js